import type { EmployerStatus } from '@duke-hq/shared-constants/employer';
import type { EmployerDetail, EmployerListRow } from './types';

function complianceForStatus(status: EmployerStatus): {
  excludedAt: Date | null;
  compliant: boolean;
} {
  switch (status) {
    case 'DO_NOT_USE':
      return { excludedAt: new Date(0), compliant: false };
    case 'DOCS_INCOMPLETE':
      return { excludedAt: null, compliant: false };
    case 'READY':
    case 'AT_CAPACITY':
      return { excludedAt: null, compliant: true };
  }
}

export function employerDetailPlaceholder(row: EmployerListRow): EmployerDetail {
  return {
    id: row.id,
    name: row.name,
    abn: row.abn,
    businessType: null,
    addressSubpremise: null,
    addressStreetNumber: null,
    addressStreetName: null,
    addressLocality: row.locality,
    addressState: row.state,
    addressPostcode: null,
    addressCountry: null,
    formattedAddress: null,
    placementCapacity: row.cap,
    excludedReason: null,
    agreementFileDrns: [],
    agreementExpiresAt: null,
    insuranceFileDrns: [],
    insuranceExpiresAt: null,
    contacts: [],
    ...complianceForStatus(row.status),
  };
}
